var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{ref:"dropzone",staticClass:"button",attrs:{"disabled":!_vm.hasDropzoneLoaded}},[_vm._v("\n    Upload Images\n  ")]),_vm._v(" "),_c('div',{ref:"preview",staticStyle:{"margin-top":"0.625rem"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }